
<div class="points__card-container">
  <app-transport-list-card 
    [style.top.px]="topPositionTransportList"
    [transportList]="transportList()"
    [maxHeight]="marginTop"
    [isOverflow]="isTransportListOverflow()"
    [pointTitle]="point().title"
    [previousPointTitle]="previousPointTitle()"
    [indexCard]="indexCard()"
    [status]="status()" 
    [isEndLocationCard]="isLocationCard()"
  />
  
  <article 
    #cardRef
    [class]="'points__card' + ' ' + status()"
    [attr.data-is-location-card]="isLocationCard()"
    (click)="goToDetailPage(point().id, point().type, 'timeline')"
  >
  
    <app-header 
      [indexCard]="indexCard()"
      [point]="point()"
      [isDuration15Minutes]="isDuration15Minutes()"
    />
    
    <app-main
      [title]="point().title"
      [id]="point().id"
      [indexCard]="indexCard()"
      [startDate]="getStartDate()"
      [durationMinutes]="point().duration"
      [isLocationCard]="isLocationCard()"
      [isDuration15Minutes]="isDuration15Minutes()"
    />
  </article>
</div>
